export default __webpack_public_path__ + "static/media/cloud-server.7e1dd5aa.svg";